import React, { useState, useRef, useEffect } from 'react';

function DataDropdown({ setSelectedProperty, data, placeholder, inputID, inputName, zIndex, value }) {
  const inputRef = useRef(null);
  const datalistRef = useRef(null);
  const containerRef = useRef(null);
  const [currentFocus, setCurrentFocus] = useState(-1);
  const [inputValue, setInputValue] = useState('');

  // Reset input when parent value changes (for clear filters)
  useEffect(() => {
    if (value !== undefined) {
      setInputValue(value);
    }
  }, [value]);

  // REMOVED THIS - it was causing the unwanted clears:
  // useEffect(() => {
  //   setInputValue('');
  // }, [data]);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        if (datalistRef.current) {
          datalistRef.current.style.display = "none";
        }
        if (inputRef.current) {
          inputRef.current.style.borderRadius = "5px";
        }
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  function handleFocus() {
    if (datalistRef.current) {
      datalistRef.current.style.display = "block";
    }
    if (inputRef.current) {
      inputRef.current.style.borderRadius = "5px 5px 0 0";
    }
  }

  function handleInput() {
    setCurrentFocus(-1);
    const text = inputRef.current?.value.toUpperCase();
    if (!datalistRef.current) return;

    for (let option of datalistRef.current.options) {
      if (option.value.toUpperCase().includes(text)) {
        option.style.display = "block";
      } else {
        option.style.display = "none";
      }
    }
  }

  function handleOptionSelect(value) {
    setInputValue(value);
    if (datalistRef.current) {
      datalistRef.current.style.display = "none";
    }
    if (inputRef.current) {
      inputRef.current.style.borderRadius = "5px";
    }

    if (setSelectedProperty) {
      setSelectedProperty(value);
    }
  }

  function addActive(options) {
    if (!options) return;
    removeActive(options);
    let newFocus = currentFocus;
    if (newFocus >= options.length) newFocus = 0;
    if (newFocus < 0) newFocus = options.length - 1;
    options[newFocus].classList.add("active");
  }

  function removeActive(options) {
    for (let option of options) {
      option.classList.remove("active");
    }
  }

  const handleKeyDown = (e) => {
    if (!datalistRef.current) return;
    if (e.keyCode === 40) {
      setCurrentFocus((prev) => {
        const newFocus = prev + 1;
        addActive(datalistRef.current.options);
        return newFocus;
      });
    } else if (e.keyCode === 38) {
      setCurrentFocus((prev) => {
        const newFocus = prev - 1;
        addActive(datalistRef.current.options);
        return newFocus;
      });
    } else if (e.keyCode === 13) {
      e.preventDefault();
      if (currentFocus > -1 && datalistRef.current.options) {
        datalistRef.current.options[currentFocus].click();
      }
    }
  };

  return (
    <div ref={containerRef} style={{ zIndex: zIndex, position: "relative" }}>
      <input
        id={inputID}
        autoComplete="on"
        role="combobox"
        list=""
        name={inputName}
        placeholder={placeholder}
        ref={inputRef}
        onFocus={handleFocus}
        onInput={handleInput}
        onKeyDown={handleKeyDown}
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value);
          handleInput();
        }}
      />
      <datalist id={inputName} role="listbox" ref={datalistRef}>
        {data && data.map((item) => (
          <option key={item} value={item} onClick={(e) => handleOptionSelect(e.target.value)}>
            {item}
          </option>
        ))}
      </datalist>
    </div>
  );
}

export default DataDropdown;